import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Check, Loader2, Star } from "lucide-react";
import { toast, Toaster } from "sonner";
import api from "../lib/api";

export function Stars({ value, onChange, size = "w-7 h-7", testid }) {
  return (
    <div className="flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" onClick={onChange ? () => onChange(i) : undefined} className={onChange ? "cursor-pointer" : "cursor-default"} data-testid={testid ? `${testid}-${i}` : undefined}>
          <Star className={`${size} ${i <= value ? "fill-brand-limeDark text-brand-limeDark" : "text-brand-soft"}`} />
        </button>
      ))}
    </div>
  );
}

export default function AvisVoyageur() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState("");
  const [note, setNote] = useState(0);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [google, setGoogle] = useState(null);
  useEffect(() => { api.get(`/public/str-review/${token}`).then((r) => setD(r.data)).catch(() => setError("Ce lien d'avis n'est pas valide.")); }, [token]);
  const send = async () => { setBusy(true); try { const r = await api.post(`/public/str-review/${token}`, { note, commentaire: txt }); setGoogle(r.data.google_url); setSent(true); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); } };
  if (error) return <div className="min-h-screen flex items-center justify-center p-6 text-brand-greenDeep" data-testid="review-error">{error}</div>;
  if (!d) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  return (
    <div className="min-h-screen bg-brand-softer flex items-center justify-center p-5" data-testid="review-page">
      <Toaster position="top-center" richColors />
      <div className="bg-white rounded-3xl border border-brand-soft p-8 w-full max-w-md">
        {sent || d.deja_note ? (
          <div className="text-center" data-testid="review-done"><Check className="w-10 h-10 mx-auto text-emerald-600" /><h1 className="font-display text-2xl font-semibold text-brand-greenDeep mt-3">Merci {d.prenom} !</h1><p className="text-sm text-brand-green/60 mt-2">Votre avis a bien été enregistré.</p>
            {google && <div className="mt-5 rounded-2xl bg-brand-softer p-4" data-testid="review-google-box">
              <p className="text-sm text-brand-greenDeep">Vous avez adoré ? Votre avis aiderait beaucoup votre hôte sur Google aussi.</p>
              <button onClick={() => { if (txt) navigator.clipboard?.writeText(txt).catch(() => {}); toast.success(txt ? "Commentaire copié : collez-le sur Google" : "Ouverture de Google"); window.open(google, "_blank", "noopener"); }} className="mt-3 w-full py-3 rounded-full bg-white border border-brand-soft font-semibold text-brand-greenDeep" data-testid="review-google-btn">Publier aussi sur Google</button>
              {txt && <p className="text-[11px] text-brand-green/50 mt-2">Votre commentaire sera copié : il suffit de le coller.</p>}
            </div>}</div>
        ) : <>
          <p className="text-xs text-brand-limeDark font-semibold uppercase tracking-[0.2em]">Votre avis</p>
          <h1 className="font-display text-3xl font-semibold text-brand-greenDeep mt-2">{d.property.name}</h1>
          <p className="text-sm text-brand-green/55 mb-5">Bonjour {d.prenom}, comment s'est passé votre séjour ?</p>
          <Stars value={note} onChange={setNote} testid="review-stars" />
          <textarea rows={5} value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="Racontez votre séjour (facultatif)" className="w-full mt-4 px-4 py-3 rounded-2xl border border-brand-soft outline-none focus:border-brand-lime text-sm" data-testid="review-text" />
          <button onClick={send} disabled={!note || busy} className="w-full mt-4 py-3 rounded-full bg-brand-greenDeep text-white font-semibold disabled:opacity-40" data-testid="review-submit">{busy ? "Envoi…" : "Publier mon avis"}</button>
        </>}
      </div>
    </div>
  );
}
